module.exports = __webpack_public_path__ + "img/IN.d51ec02e.png";